// #region initial state: listings
/**
 * @typedef {Object} ListingsBenchmarkData
 * @property {number} activeListings
 * @property {number} favsListings
 * @property {number} clicksListings
 * @property {number} searchListings
 */

/**
 * @typedef {Object} ListingsBenchmarkResponse
 * @property {ListingsBenchmarkData} current
 * @property {ListingsBenchmarkData} previous
 */

/**
 * @constant listingsBenchmarkDataInitialState
 * @type {ListingsBenchmarkResponse}
 */
export const listingsBenchmarkDataInitialState = {
  current: {
    activeListings: 0,
    favsListings: 0,
    clicksListings: 0,
    searchListings: 0,
  },
  previous: {
    activeListings: 0,
    favsListings: 0,
    clicksListings: 0,
    searchListings: 0,
  },
};
// #endregion initial state: listings

// #region initial state: topListings
/**
 * @typedef {'byFavourites'|'byLeads'|'byViews'} ListingsBenchmarkTopListingsCategory
 */

/**
 * @typedef {Object} ListingsBenchmarkTopListingsDataDetails
 * @property {string} makerModel
 * @property {string} modelDetails
 * @property {number} price
 * @property {string} currency
 * @property {number} taxPercentage
 * @property {string} publishDate
 * @property {string} unpublishDate
 * @property {string} imageUrl
 * @property {string} imageAlt
 */

/**
 * @typedef {Object} ListingsBenchmarkTopListingsData
 * @property {number} rank
 * @property {number} statCount
 * @property {string} listingId
 * @property {ListingsBenchmarkTopListingsDataDetails} details
 */

/**
 * @typedef {Object} ListingsBenchmarkTopListingsResponse
 * @property {ListingsBenchmarkTopListingsData[]} clicks
 * @property {ListingsBenchmarkTopListingsData[]} leads
 * @property {ListingsBenchmarkTopListingsData[]} favs
 */

/**
 * @constant topListingsBenchmarkInitialState
 * @type {ListingsBenchmarkTopListingsResponse}
 */
export const topListingsBenchmarkInitialState = {
  clicks: [],
  leads: [],
  favs: [],
};
// #endregion initial state: topListings

// #region initial state: listingsTurnover
/**
 * @typedef {Object} ListingsBenchmarkListingsTurnoverData
 * @property {number} days0to30
 * @property {number} days31to60
 * @property {number} days61to90
 * @property {number} days90plus
 */

/**
 * @typedef {Object} ListingsBenchmarkListingsTurnoverResponse
 * @property {ListingsBenchmarkListingsTurnoverData} turnover
 * @property {number} avgDaysOnline
 * @property {number} previousAvgDelta
 */

/**
 * @constant listingsTurnoverListingsBenchmarkInitialState
 * @type {ListingsBenchmarkListingsTurnoverResponse}
 */
export const listingsTurnoverListingsBenchmarkInitialState = {
  turnover: {
    days0to30: 0,
    days31to60: 0,
    days61to90: 0,
    days90plus: 0,
  },
  avgDaysOnline: 0,
  previousAvgDelta: 0,
};
// #endregion initial state: listingsTurnover

// #region initial state: listingsImages
/**
 * @typedef {Object} ListingsBenchmarkListingsImagesDayData
 * @property {number} count
 * @property {number} previousPeriodDelta
 */

/**
 * @typedef {Object} ListingsBenchmarkListingsImagesNetworkData
 * @property {number} minimum
 * @property {number} maximum
 */

/**
 * @typedef {Object} ListingsBenchmarkListingsImagesData
 * @property {ListingsBenchmarkListingsImagesDayData} images0to1
 * @property {ListingsBenchmarkListingsImagesDayData} images2to10
 * @property {ListingsBenchmarkListingsImagesDayData} averageImagesPerListing
 * @property {ListingsBenchmarkListingsImagesNetworkData} networkImagesPerListing
 */

/**
 * @constant listingsImagesListingsBenchmarkInitialState
 * @type {ListingsBenchmarkListingsImagesData}
 */
export const listingsImagesListingsBenchmarkInitialState = {
  images0to1: {
    count: 0,
    previousPeriodDelta: 0,
  },
  images2to10: {
    count: 0,
    previousPeriodDelta: 0,
  },
  averageImagesPerListing: {
    count: 0,
    previousPeriodDelta: 0,
  },
  networkImagesPerListing: {
    minimum: 0,
    maximum: 0,
  },
};
// #endregion initial state: listingsImages
